import { Check } from '@phosphor-icons/react'
import { motion } from 'framer-motion'
import { PACKAGES, formatQ } from '../data/travel'

const ease = [0.16, 1, 0.3, 1]

export default function Packages() {
  const featured = PACKAGES.find((p) => p.featured) ?? PACKAGES[0]
  const rest = PACKAGES.filter((p) => p !== featured)

  return (
    <section id="paquetes" className="scroll-mt-16 px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-navy-950 md:text-5xl">
          Paquetes armados para no pensar en nada.
        </h2>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <motion.article
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease }}
            className="relative min-h-[520px] overflow-hidden rounded-2xl text-white lg:col-span-7"
          >
            <img src={featured.image} alt={featured.place} className="absolute inset-0 size-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/90 via-navy-950/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-7 md:p-9">
              <p className="text-sm font-medium text-white/75">{featured.place}</p>
              <h3 className="mt-1 font-display text-3xl font-extrabold tracking-tight md:text-4xl">{featured.name}</h3>
              <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {featured.includes.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-white/90">
                    <Check size={16} weight="bold" className="mt-0.5 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mt-6 flex flex-wrap items-end justify-between gap-4">
                <p className="text-sm text-white/75">
                  {featured.nights} noches, por persona
                  <span className="block font-display text-3xl font-extrabold text-white">{formatQ(featured.price)}</span>
                </p>
                <a
                  href={`https://wa.me/50239990332?text=${encodeURIComponent(`Hola, estoy interesado en el viaje a ${featured.name}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-xl bg-white px-5 py-3 text-sm font-semibold text-navy-950 transition-colors hover:bg-sunset-50"
                >
                  Pedir cotización
                </a>
              </div>
            </div>
          </motion.article>

          <div className="flex flex-col gap-6 lg:col-span-5">
            {rest.map((pkg, i) => (
              <motion.article
                key={pkg.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, ease, delay: 0.1 + i * 0.1 }}
                className="grid flex-1 grid-cols-[120px_1fr] overflow-hidden rounded-2xl bg-white sm:grid-cols-[180px_1fr]"
              >
                <div className="relative min-h-[200px]">
                  <img src={pkg.image} alt={pkg.place} className="absolute inset-0 size-full object-cover" />
                </div>
                <div className="flex flex-col p-5">
                  <p className="text-sm text-navy-700/60">{pkg.place}</p>
                  <h3 className="mt-1 font-display text-xl font-bold text-navy-950">{pkg.name}</h3>
                  <ul className="mt-3 flex flex-col gap-1.5">
                    {pkg.includes.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-sm text-navy-700/60">
                        <Check size={15} weight="bold" className="mt-0.5 shrink-0 text-sunset-500" />
                        {item}
                      </li>
                    ))}
                  </ul>
                  <p className="mt-auto pt-4 text-sm text-navy-700/60">
                    {pkg.nights} noches, desde{' '}
                    <span className="font-display text-xl font-extrabold text-navy-950">{formatQ(pkg.price)}</span>
                  </p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
